// Single-line text input with label. Empty string passes through to onChange
// as-is — callers decide whether to treat empty as null.

interface TextFieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  hint?: string;
  type?: 'text' | 'tel' | 'email' | 'url';
  disabled?: boolean;
  monospace?: boolean;
  required?: boolean;
  dir?: 'ltr' | 'rtl';
}

export function TextField({
  label,
  value,
  onChange,
  placeholder,
  hint,
  type = 'text',
  disabled,
  monospace,
  required,
  dir,
}: TextFieldProps) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[11px] font-medium uppercase tracking-wide text-[color:var(--bo-mute)]">
        {label}
        {required ? <span className="ms-0.5 text-[#9f1239]">*</span> : null}
      </span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        dir={dir}
        className={`h-10 w-full rounded-md border border-[color:var(--bo-line)] bg-white px-3 text-[13px] text-[color:var(--bo-ink)] focus:border-[color:var(--bo-mute)] focus:outline-none disabled:cursor-not-allowed disabled:bg-[color:var(--bo-bg)] disabled:text-[color:var(--bo-mute)] ${
          monospace ? 'font-mono text-[12px]' : ''
        }`}
      />
      {hint ? <span className="text-[11px] text-[color:var(--bo-mute)]">{hint}</span> : null}
    </label>
  );
}
